import { Pipe, PipeTransform } from "@angular/core";
import * as moment from "moment-timezone";

@Pipe({
  name: "dateNow"
})
export class DateNowPipe implements PipeTransform {
  transform(value: any, propName: string) {
    moment.locale("pt-br");
    const date = moment.tz(value, "America/Sao_Paulo");
    return moment(date).fromNow();
  }
}
